class BESSAppProjectsAPIService extends BESSAppAPIServiceBase {

    constructor(parent) {
        super(parent, 'project/');
    }

    apiDelete(projectId, onSaved, onError = null) {
        this._post('delete', {
            data: {
                'project_id': projectId,
            },
            onResult: onSaved,
            onError: onError,
        });
    }

    apiRecalculate(projectId, onSaved, onError = null) {
        this._post('recalc', {
            data: {
                'project_id': projectId,
            },
            onResult: onSaved,
            onError: onError,
        });
    }

    apiCopy(projectId, newProjectName, onSaved, onError = null) {
        this._post('copy', {
            data: {
                'project_id': projectId,
                'new_project_name': newProjectName,
            },
            onResult: onSaved,
            onError: onError,
        });
    }

    apiMonitorCopy(projectId, onSaved, onError = null) {
        this._post('monitor-copy', {
            data: {
                'project_id': projectId,
            },
            onResult: onSaved,
            onError: onError,
        });
    }
}